module.exports = __webpack_public_path__ + "img/MAU-Logo-2022.23eb7fd.png";